import React from "react";
import { QuotaDataObject } from "./QuotaTableType";

interface ProgressDetailInfoProps {
    details: QuotaDataObject | null;
}

export const ProgressDetailInfo: React.FC<ProgressDetailInfoProps> = ({
    details,
}) => {
    return (
        <div className="progress_detail_box">
            <div className="progress_inner_detail_box">
                <div className="detail_inner_data_box">
                    <div className="available_data_box fill_data_box"></div>
                </div>
                <div className="available_data_info">
                    <p className="info_title_text">Used</p>
                    <p className="info_title_inner_text">
                        {details?.used_gb.toFixed(2)} GB
                    </p>
                </div>
            </div>
            <div className="progress_inner_detail_box progress_inner_detail_box_right">
                <div className="detail_inner_data_box">
                    <div className="available_data_box"></div>
                </div>
                <div className="available_data_info">
                    <p className="info_title_text">Available</p>
                    <p className="info_title_inner_text">
                        {details?.avail_gb.toFixed(2)} GB
                    </p>
                </div>
            </div>
        </div>
    );
};
